<template>
    <div>
        <nav
            v-if="links && links.filter(l => /^\d+$/.test(String(l.label))).length > 1"
            class="mt-8"
        >
            <ul class="flex gap-2">
                <li v-for="link in normalized" :key="link._idx">
                    <a
                        :href="link.url || '#'"
                        class="btn btn--tab btn--tab--with-icon btn-grey-200 w-full mb-4 flex items-end leading-none"
                        :class="link.active ? 'bg-primary text-white' : ''"
                        v-html="link._label"
                        @click="link._hasUrl ? handlePaginateLinkClick($event, link.url) : null"
                    />
                </li>
            </ul>
        </nav>
    </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { computed } from "vue";

const router = useRouter();

const props = defineProps({
    links: {
        type: Array,
        default: () => []
    }
});

const normalized = computed(() =>
    (Array.isArray(props.links) ? props.links : []).map((l, i) => ({
        ...l,
        _idx: i,
        _hasUrl: !!l?.url,
        _label: String(l?.label ?? "")
    }))
);

const handlePaginateLinkClick = (event, url) => {
    event.preventDefault();
    if (!url) return;
    const paged = String(url).split("?page=");
    const page = paged[1] ? Number(paged[1]) : null;
    if (page) {
        router.push({
            name: "account/manage-users/paged",
            params: { page }
        });
    }
};
</script>
